<template>
  <div
    v-if="hasFlashValue"
    class="space-y-3 p-5">
    <alert
      v-if="flash.error"
      type="error"
      :message="flash.error" />
    <alert
      v-if="flash.warning"
      type="warning"
      :message="flash.warning" />
    <alert
      v-if="flash.success"
      type="success"
      :message="flash.success" />
    <alert
      v-if="flash.info"
      type="info"
      :message="flash.info" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import Alert from '@/Components/Alert.vue';

const page = usePage();

// Access `flash` directly from `page.props`
const flash = computed(() => page.props.flash || {});

// Check if any non-null flash values exist
const hasFlashValue = computed(() => Object.values(flash.value).some((value) => value !== null));
</script>
